






import { Component, Mixins } from 'vue-property-decorator'
import AuthedHeader from '@/components/student/organisms/AuthedHeader.vue'
import CookieMethods from '@/mixins/CookieMethods.vue'

@Component({
  components: {
    AuthedHeader,
  },
})
export default class StudentAuthedLayout extends Mixins(CookieMethods) {
  private created() {
    // 認証情報が存在しない場合はログアウト
    if (!this.isTokensExist) this.logout()
  }

  /**
   * ログアウト処理
   *
   * クッキーを削除しログイン画面へ遷移する
   */
  private async logout() {
    await this.resetAuthAcbt()
    this.$router.push({ name: 'StudentLogin' })
  }
}
